import { BooleanGambit } from 'flarum/common/query/IGambit';
export default class BlogGambit extends BooleanGambit {
  key() {
    return 'blog';
  }
  filterKey() {
    return 'blog';
  }
}
flarum.reg.add('v17development-blog', 'common/query/BlogGambit', BlogGambit);